import { takeEvery, all } from 'redux-saga/effects';
import { userTypes } from '../actions';

function* initialize() {}

export default function* UserSagas() {
  yield all([takeEvery(userTypes.INITIALIZE, initialize)]);
}
